import React from "react";
import Papa from "papaparse";
import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { downloadZip } from "../../utils/downloadZip";
import { downloadService } from "../../services/downloadService";
import TrackedButton from "../BasicUserTracking/TrackedButton";

const handleDownload = (data: unknown[], name: string) => {
  const csv = Papa.unparse(data);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;

  const date = new Date();
  const formattedDate = date.toISOString().split("T")[0].replace(/-/g, "");

  link.setAttribute("download", `${formattedDate}_${name}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default function TableDowloadButton({
  data,
  downloadURL,
  name,
  disabled,
  selector,
  subjectId,
  downloadImages,
}: {
  data?: any;
  name?: string;
  disabled?: boolean;
  downloadImages?: boolean;
  selector?: string;
  downloadURL?: string;
  subjectId?: string;
}) {
  const downloadClick = async () => {
    if (downloadURL) {
      await downloadService.downloadApiFileWithGET(downloadURL, name ?? "");
    } else if (downloadImages) {
      downloadZip(data, name, selector, subjectId);
    } else {
      handleDownload(data, name ?? "");
    }
  };

  return (
    <Tooltip
      title={
        downloadImages
          ? "Export all of the plots (PNGs) and data tables (CSVs) on this page. The downloaded plots will appear as on screen. The downloaded table(s) will not include filters and sorting, and will include additional useful data columns not shown in Vivo."
          : "Export the data on this page as a CSV. Exported file will not include filters and sorting, and will include additional useful data columns not shown in Vivo."
      }
    >
      <div className="flex items-center">
        <TrackedButton
          actionName="Table export"
          trackingMetadata={{
            downloadType: downloadImages
              ? "images_and_csv"
              : downloadURL
                ? "file"
                : "csv",
            tableName: name,
          }}
          onClick={downloadClick}
        >
          <Button
            type="text"
            icon={<DownloadOutlined />}
            style={{
              color: "#064C68",
              width: "80px",
              fontWeight: 700,
            }}
            disabled={disabled}
          >
            Export
          </Button>
        </TrackedButton>
      </div>
    </Tooltip>
  );
}
